import React from 'react';
import { motion } from 'framer-motion';
export function BeliefShiftSection() {
  return <section className="py-32 bg-secondary flex flex-col items-center justify-center text-center px-6" data-id="element-1">
      <div className="max-w-5xl mx-auto w-full" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-20" data-id="element-3">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-4">
            La atracción no se crea siendo correcto.
          </h2>
          <p className="text-xl text-gray-400" data-id="element-5">
            Se crea siguiendo una secuencia.
          </p>
        </motion.div>

        {/* Progression Graphic */}
        <div className="relative flex justify-between items-center max-w-3xl mx-auto mb-20" data-id="element-6">
          {/* Connecting Line */}
          <div className="absolute top-1/2 left-0 w-full h-0.5 bg-gray-800 -z-10" data-id="element-7"></div>
          <motion.div initial={{
          width: '0%'
        }} whileInView={{
          width: '100%'
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.5,
          ease: 'easeInOut',
          delay: 0.5
        }} className="absolute top-1/2 left-0 h-0.5 bg-gradient-to-r from-gray-600 via-gold to-gold -z-10" data-id="element-8"></motion.div>

          {/* Step 1 */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="flex flex-col items-center bg-secondary p-4" data-id="element-9">
            <div className="w-16 h-16 rounded-full border-2 border-gray-600 flex items-center justify-center mb-4 bg-secondary text-gray-400 font-bold" data-id="element-10">
              01
            </div>
            <span className="text-sm uppercase tracking-widest text-gray-400 font-semibold" data-id="element-11">
              Emoción
            </span>
          </motion.div>

          {/* Step 2 */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 1.0
        }} className="flex flex-col items-center bg-secondary p-4" data-id="element-12">
            <div className="w-20 h-20 rounded-full border-2 border-gold/50 flex items-center justify-center mb-4 bg-secondary text-gold/80 font-bold shadow-[0_0_15px_rgba(201,168,76,0.2)]" data-id="element-13">
              02
            </div>
            <span className="text-sm uppercase tracking-widest text-gold/80 font-semibold" data-id="element-14">
              Conexión
            </span>
          </motion.div>

          {/* Step 3 */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 1.5
        }} className="flex flex-col items-center bg-secondary p-4" data-id="element-15">
            <div className="w-24 h-24 rounded-full border-2 border-gold flex items-center justify-center mb-4 bg-secondary text-gold font-bold shadow-[0_0_30px_rgba(201,168,76,0.4)]" data-id="element-16">
              03
            </div>
            <span className="text-sm uppercase tracking-widest text-gold font-bold" data-id="element-17">
              Escalada
            </span>
          </motion.div>
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 2
      }} className="text-2xl text-white font-light max-w-3xl mx-auto leading-relaxed" data-id="element-18">
          No necesitás frases. No necesitás técnicas. Necesitás entender el
          orden correcto.{' '}
          <span className="text-gold font-semibold" data-id="element-19">
            The F-Formula es ese orden.
          </span>
        </motion.p>
      </div>
    </section>;
}